/**
 * @file Home.tsx
 * @description Ultimind home page with hero, value propositions, and key use cases.
 */

import { HeroSection } from '../components/home/HeroSection'
import { ValueGrid } from '../components/home/ValueGrid'
import { UseCasesSection } from '../components/home/UseCasesSection'
import { CallToActionSection } from '../components/home/CallToActionSection'

/**
 * HomePage component renders the main landing page of the Ultimind site.
 */
export default function HomePage() {
  return (
    <>
      <HeroSection />
      <ValueGrid />
      <UseCasesSection />
      <CallToActionSection />
    </>
  )
}
